/** `otpauth://totp/Issuer:account?secret=...&issuer=...` for the manual-entry fallback. */
export interface OtpauthParts {
  issuer: string;
  account: string;
  secret: string;
}

export function parseOtpauthUri(uri: string): OtpauthParts | null {
  const match = /^otpauth:\/\/totp\/([^?]*)\?(.*)$/i.exec(uri || '');
  if (!match) return null;
  const label = safeDecode(match[1] ?? '');
  const params: Record<string, string> = {};
  for (const pair of (match[2] ?? '').split('&')) {
    const eq = pair.indexOf('=');
    if (eq < 0) continue;
    params[pair.slice(0, eq).toLowerCase()] = safeDecode(pair.slice(eq + 1));
  }
  const colon = label.indexOf(':');
  const labelIssuer = colon >= 0 ? label.slice(0, colon) : '';
  const account = colon >= 0 ? label.slice(colon + 1) : label;
  const secret = params['secret'] ?? '';
  if (!secret) return null;
  return { issuer: params['issuer'] || labelIssuer, account: account.trim(), secret };
}

/** `JBSWY3DPEHPK3PXP` -> `JBSW Y3DP EHPK 3PXP`, easier to type into an app. */
export function formatSecret(secret: string): string {
  return (secret || '').replace(/\s/g, '').replace(/(.{4})(?=.)/g, '$1 ');
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value.replace(/\+/g, ' '));
  } catch {
    return value;
  }
}
